export const times = {
  // 该混入是适用于在线练习和练习监控的方法共用
  data() {
    return {
      overTimerState: false,
      overTimer: null // 超时定时器
    };
  },
  methods: {
    // // 判断是否超时
    timeIsaddtest() {
      // 开启定时器 20分钟后提示弹窗
      // this.overTimer = setTimeout(() => {
      //   this.$refs.popup.dialogVisibleObj.prompt = true;
      // }, 1200000);
      // 产品修改成三十分钟 
      this.overTimer = setTimeout(() => {
        // this.$refs.popup.dialogVisibleObj.prompt = true;
        this.$alert(
          "您选题时间较长，请尽快完成组卷。",
          "温馨提示",
          {
            confirmButtonText: "确定",
            callback: action => {
                this.overTimerState = false
            }
          }
        );
        // 
      },1800000);
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.overTimer);
      });
    },
    cleanTime() {
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.overTimer);
        this.overTimer = null;
      });
    }
  },
  beforeDestroy() {
    // 销毁定时器
    clearInterval(this.overTimer);
    this.overTimer = null;
  }
};
